































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { DatePicker, Popover } from 'element-ui';
import { AcgnPop } from '@acgn/herm/src/ui';
import { AcgnFormContent, AcgnFormTitle, AcgnProcedureEdit } from '@/components/';
import { namespace } from 'vuex-class';
import { getDateTimeStamp, setDateTimeStamp } from '@acgn/herm/src/util/time';
import { complexClone } from '@acgn/herm/src/util/serialize';
const TaskGroupAction = namespace('desk/taskGroup').Action;
const TaskGroupGetter = namespace('desk/taskGroup').Getter;
const ComicAction = namespace('desk/comic').Action;
const ComicGetter = namespace('desk/comic').Getter;
export interface FormData {
  task_name: string;
  dead_line: string;
}

@Component({
  components: {
    AcgnPop,
    [DatePicker.name]: DatePicker,
    AcgnProcedureEdit,
    AcgnFormTitle,
    AcgnFormContent,
    [Popover.name]: Popover
  }
})
export default class AcgnAddTask extends Vue {
  @Prop() public comicId: any; // 项目id
  @Prop() public taskGroupId: any; // 项目id
  @Prop() public visible: any; // 是否显示弹框
  @Prop() public refreshTaskList: any; // 刷新任务列表
  private formData: FormData = {
    task_name: '',
    dead_line: ''
  };
  private isSort: any = false;
  private workflowList: any = [];
  private oldList: any = [];
  private newworkflowList: any = [];
  private firstName: any = '';
  @ComicAction private sortTemplateLink: any; // 环节排序
  @TaskGroupAction private createTask: any; // 添加任务
  @TaskGroupAction private getLinks: any; // 默认环节
  @TaskGroupAction private addTemplate: any; // 添加环节
  @TaskGroupGetter private loadings: any; // 任务组loading
  private pickerOptions: any = {
    disabledDate(time: any) {
      return time.getTime() + 86400000 <= Date.now(); // 选当前时间之后的时间
    }
  };

  get show() {
    return this.visible;
  }

  set show(v) {
    this.$emit('update:visible', v);
  }

  @Watch('visible')
  private getVisible() {
    this.formData = {
      task_name: '',
      dead_line: ''
    };
  }

  // 排序
  private async getSort() {
    this.isSort = !this.isSort;
    if (!this.isSort) {
      this.newworkflowList.map((i: any, j: any) => {
        i.orders = j + 1;
      });
      const {result} = await this.sortTemplateLink({templateList: this.newworkflowList});
    }
  }

  // 获取新的排序值
  private getNewWork(data: any) {
    this.newworkflowList = data;
    this.firstName = this.newworkflowList[0].template_name;
  }

  // 流程设置
  private async getFlowList() {
    const params = {
      project_id: this.comicId
    };
    const { result } = await this.getLinks(params);
    this.workflowList = result;
    this.firstName = this.workflowList[0].template_name;
    this.oldList = complexClone(result);
    this.newworkflowList = result;
  }

  private created() {
    this.getFlowList();
  }

  // 提交验证
  private async getParams() {
    let index = 0;
    for (const i of this.newworkflowList) {
      let hasChange = false;
      i.orders = ++index + 1;
      this.oldList.map((j: any) => {
        if (j.id === i.id && j.template_name === i.template_name && j.process_code === i.process_code) {
          hasChange = true;
        }
      });
      if (!hasChange) {
        const params = {
          project_id: this.comicId,
          template_name: i.template_name,
          process_code: i.process_code,
          project_type: 1,
        };
        const {result} = await this.addTemplate(params);
        i.id = result;
      }
    }
  }

  // 提交任务
  private async submit() {
    await this.getParams();
    (this.$refs.formtask as any).validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }
      try {
        const temp = getDateTimeStamp(this.formData.dead_line , 'YYYY-MM-DD HH:mm:ss');
        this.formData.dead_line = setDateTimeStamp(temp, 'YYYY-MM-DD HH:mm:ss');
        const params = {
          ...this.formData,
          project_id: this.comicId,
          task_group_id: this.taskGroupId,
          links: this.newworkflowList
        };
        await this.createTask(params);
        this.show = false;
        this.$message.success('创建任务成功');
        this.refreshTaskList();
      } catch (ex) {
        this.$message.error(ex.message);
      }
    });
  }

  // 任务验证
  private get rules() {
    const rules = {
      task_name: [
        { required: true, message: '请输入任务组名称', trigger: 'blur' }
      ],
      dead_line: [
        { required: true, type: 'date', message: '请输入截止时间', trigger: 'blur' }
      ]
    };
    return rules;
  }
}
